import styled from 'styled-components';

const StyledFloatingCards = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 30px 0 50px 0;
    
  @media only screen and (max-width: 1160px) {
    margin: 30px 0 20px 0;
  }
  
    @media only screen and (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
`;

export default StyledFloatingCards;
